import React, {PropsWithChildren, ReactElement, ReactNode, useCallback, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Container} from '@yosmanyga/rich-ui';
import {PlayBoard} from './Play/PlayBoard';
import {PlayInput} from './Play/PlayInput';
import {PlayInputNotePrompt} from './Play/PlayInputNotePrompt';

const Play = observer(({
    templates,
    onInput,
    onNavigateToRestore,
    onNavigateToHelp,
}: {
    templates: {
        layout: (
            params: {
                id: string,
                story: ReactElement,
                input: ReactElement;
            }
        ) => ReactNode;
    },
    onInput: () => void,
    onNavigateToRestore: () => void,
    onNavigateToHelp: () => void
}) => {
    const [id, setId] = useState('play');

    const InputLayout = useCallback(() => {
        return <>
            <PlayInputNotePrompt/>

            <PlayInput
                templates={{
                    layout: ({children}: PropsWithChildren) => {
                        return <Container>
                            {children}
                        </Container>;
                    },
                }}
                onInput={(input) => {
                    setId(input);

                    onInput();
                }}
                onNavigateToRestore={onNavigateToRestore}
                onNavigateToHelp={onNavigateToHelp}
            />
        </>
    }, [])

    return <templates.layout
        id={id}
        story={<PlayBoard/>}
        input={<InputLayout/>}
    />
});

export {Play};
